import { render } from "./Contributions.vue?vue&type=template&id=ebcf37e4"
import script from "./Contributions.vue?vue&type=script&lang=js"
export * from "./Contributions.vue?vue&type=script&lang=js"

import "./Contributions.vue?vue&type=style&index=0&id=ebcf37e4&lang=css"

import exportComponent from "C:\\Mahoro\\projects\\crane\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__